<template>
	<div class="rb-player-timeline">
		<rb-player-timeline-bar
			:end="video.duration"
			:duration="video.duration"
			class="bar-base"
		></rb-player-timeline-bar>

		<!-- Buffer bars -->

		<rb-player-timeline-bar
			v-for="buffer in video.buffered" :key="buffer[0]"
			:start="buffer[0]"
			:end="buffer[1]"
			:duration="video.duration"
			class="bar-buffer"
		></rb-player-timeline-bar>

		<!-- /Buffer bars -->

		<rb-player-timeline-bar
			:end="video.position"
			:duration="video.duration"
			class="bar-progress"
		></rb-player-timeline-bar>

		<rb-player-timeline-bar
			:end="video.duration"
			:duration="video.duration"
			class="click-area"
			@mousemove.native="mouseMove"
			@click.native.prevent.stop="click"
			ref="clickArea">

			<div class="marker dot" :style="{left: dotX+'px'}">
				<span class="label">
					{{ virtualPositionTimestamp }}
				</span>
			</div>

			<div class="marker cue"
				 v-for="cue in cues"
				 :key="cue.position"
				 :style="cssPositionFromSeconds(cue.position)"
				 @click.native.prevent.stop="video.seek(cue.position)">
				<span class="label">
					{{ cue.label }}
				</span>
			</div>

		</rb-player-timeline-bar>
	</div>
</template>

<script>
	import {secondsToTimestamp} from '../util/secondsToTimestamp';
	import {VideoPlayer} from '../VideoPlayer';

	import RbPlayerTimelineBar from './RbPlayerTimelineBar';

	export default {
		name: 'RbPlayerTimeline',
		components: {RbPlayerTimelineBar},
		props: {
			video: {
				type: VideoPlayer,
				required: true
			},
			cues: {
				type: Array,
				required: true
			}
		},
		data: () => ({
			dotX: 0
		}),
		computed: {
			virtualPosition() {
				if (!this.video.duration || !this.dotX) return 0;

				let rect = this.$refs.clickArea.$el.getBoundingClientRect();

				return this.video.duration * (this.dotX / rect.width);
			},
			virtualPositionTimestamp() {
				return secondsToTimestamp(this.virtualPosition);
			}
		},
		methods: {
			mouseMove(e) {
				let rect = this.$refs.clickArea.$el.getBoundingClientRect();
				this.dotX = e.clientX - rect.left; //x position within the element.

				if (this.dotX < 0) this.dotX = 0;
				if (this.dotX > rect.width) this.dotX = rect.width;
			},
			click(e) {
				let rect = this.$refs.clickArea.$el.getBoundingClientRect();
				let x = e.clientX - rect.left;

				let position = this.video.duration * (x / rect.width);

				this.video.seek(position);
			},
			cssPositionFromSeconds(seconds) {
				return {
					left: (seconds / this.video.duration) * 100 + '%'
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-player-timeline	{
		.bar-base {
			background-color: rgba($grey, 0.3);
			box-shadow: 0 0 5px rgba($highlight, .3);
		}

		.bar-buffer {
			background-color: rgba($grey, .5);
			transition: none;
		}

		.bar-progress {
			background-color: rgba($highlight, 1);
			left: 0;
		}

		.click-area {
			height: 30px;
			cursor: pointer;

			.cue {
				opacity: 0;
				transform: translate(-50%, -75%);
			}

			&:hover {
				.cue {
					opacity: .9;
					transform: translate(-50%, -50%);
				}
			}
		}

		.marker {
			position: absolute;
			top: 50%;
			transform: translate(-50%, -50%);

			&:before {
				content: '';
				position: absolute;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			&.dot {
				padding: 15px;

				&:before {
					$size: 5px;
					width: $size;
					height: $size;
					background-color: rgba($highlight, 0.9);
					box-shadow: 0 0 8px rgba($highlight, 1);
					border-radius: 50%;
				}

				opacity: 0;
				transition: opacity .2s;

				&:hover {
					opacity: .9;
				}
			}

			&.cue {
				$size: 10px;
				transition: all .2s;
				padding: $size * 1.5;

				&:before {
					width: $size;
					height: $size;

					transform: translate(-50%, -50%) rotate(45deg);

					border: 1px solid $secondary;
					box-shadow: 0 0 8px rgba($secondary-2, 1);
				}

				.label {
					opacity: 0;
					transition: opacity .2s;
				}

				&:hover {
					.label {
						opacity: .9;
					}
				}
			}

			.label {
				position: absolute;
				pointer-events: none;
				min-width: 15px;
				font-size: $font-size-xxs;

				transform: translate(-50%, -100%);
			}
		}
	}
</style>
